export const CHART_COLORS = ['#28D0D0', '#528AA9', '#59C390'];

export const POPULATION_AGES = [
  '전체',
  '10대 미만',
  '10대',
  '20대',
  '30대',
  '40대',
  '50대',
  '60대',
  '60대 초과',
];

export const OFFICE_WORKER_AGES = [
  '전체',
  '10대',
  '20대',
  '30대',
  '40대',
  '50대',
  '60대',
  '60대 초과',
];

export const GENDER_LABELS: {[key: string]: string} = {
  male: '남성',
  female: '여성',
};

export const HOUSE_POPULATION_CHART_INFO: {
  [key: string]: {color: string; label: string; order: number};
} = {
  aptCount: {
    color: '#F03C51',
    label: '아파트',
    order: 1,
  },
  officeCount: {
    color: '#FFAF01',
    label: '오피스텔',
    order: 2,
  },
  houseCount: {
    color: '#45BB7F',
    label: '단독주택',
    order: 3,
  },
  villaCount: {
    color: '#4C9BFA',
    label: '빌라',
    order: 4,
  },
};

export const POPULATION_TIME_DAY = ['전체', '평일', '주말'];
export const POPULATION_TIME_HOUR = [
  {time: 6, name: '오전'},
  {time: 11, name: '점심'},
  {time: 15, name: '오후'},
  {time: 18, name: '저녁'},
  {time: 21, name: '밤'},
];

export const STUDENT_TABS = [
  '어린이집',
  '유치원',
  '초등학교',
  '중학교',
  '고등학교',
  '대학교',
];

export const STUDENT_TYPES = [
  'daycareCenter',
  'kindergarten',
  'elementary',
  'middle',
  'high',
  'university',
];

export const STORE_COUNT_TABS = ['총 매장 수', '활성 매장 수'];

export const HOUSE_SALES_TYPES = [
  {key: 'totalEstSales', label: '총 매출액'},
  {key: 'avgEstSales', label: '매장당 매출액'},
  {key: 'cardSalesAvg', label: '1회당 평균 결제금액(객단가)'},
];

export const AGE_GENDER_SUBJECTS = [
  '10대',
  '20대',
  '30대',
  '40대',
  '50대',
  '60대',
  '60대 초과',
];

export const SALES_WEEK_WEEKEND_LABELS = [
  '월',
  '화',
  '수',
  '목',
  '금',
  '토',
  '일',
];
export const SALES_TIME_LABELS = ['새벽', '오전', '점심', '오후', '저녁', '밤'];

export enum EMPTY_ITEM_TYPES {
  Population = 'Population',
  Sales = 'Sales',
}
